import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IComparatorResponse } from '../../apps/comparator/models';
import { RootState } from '../../store';
import { fetchComparatorDataAsync } from './thunk';

export interface IComparatorStateProps {
  status: 'idle' | 'loading' | 'failed';
  comparatorData: IComparatorResponse;
}

const initialState: IComparatorStateProps = {
  status: 'idle',
  comparatorData: {
    products: [],
    carouselName: '',
    meta: {
      productAttributes: [],
    },
  },
};

export const comparatorSlice = createSlice({
  name: 'comparator',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchComparatorDataAsync.fulfilled,
      (state, action: PayloadAction<IComparatorStateProps['comparatorData']>) => {
        state.status = 'idle';
        state.comparatorData = action.payload;
      },
    );
    builder.addCase(fetchComparatorDataAsync.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(fetchComparatorDataAsync.rejected, (state) => {
      state.status = 'failed';
    });
  },
});

export const getComparatorData = (state: RootState) => state.comparator.comparatorData;

export const getComparatorStatus = (state: RootState) => state.comparator.status;

export default comparatorSlice.reducer;
